module.exports = __webpack_public_path__ + "static/img/slogan.a2101b1.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/home/pc/index1/slogan.png
// module id = dqje
// module chunks = 7